import axios from 'axios';
import useAuthStore from '../store/authStore';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().clearUser();
    }
    return Promise.reject(error);
  }
);

export const getAllAuthors = async () => {
  const response = await api.get('/authors');
  return response.data;
};

export const getAuthorById = async (id) => {
  const response = await api.get(`/authors/${id}`);
  return response.data;
}

export const getEbooksByAuthor = async (userId, page = 1, limit = 10, orderBy = 'created_at', order = 'DESC') => {
  const response = await api.get(`/authors/${userId}/ebooks`, {
    params: {
      page,
      limit,
      order_by: orderBy,
      order
    }
  });
  return response.data;
};